import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-subtitle-hr',
  templateUrl: './subtitle-hr.component.html',
  styleUrls: ['./subtitle-hr.component.css']
})
export class SubtitleHrComponent {
  @Input('title') title: string = "";
  @Input('background') background!: string;
  
}
